import type { CatalogFacility } from '@catalog';

export function selectionIncludesAsc(facilities: CatalogFacility[], codes: string[]): boolean {
  return codes.some((code) => facilities.find((facility) => facility.code === code)?.has_asc === true);
}
